import { useState } from 'react';

import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { AccountHolder } from 'src/models';

import { FinancialInformationEmploymentForm } from './FinancialInformationEmploymentForm';
import { FinancialInformationEmploymentView } from './FinancialInformationEmploymentView';

interface OtherAccountHolderFinancialEmploymentSectionProps {
  accountHolder: AccountHolder;
}

export const OtherAccountHolderFinancialEmploymentSection = ({
  accountHolder,
}: OtherAccountHolderFinancialEmploymentSectionProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  if (account?.type.isIndividual || account?.type.isRetirement) {
    return null;
  }

  return (
    <MFormSection
      title='Employment Information'
      onEdit={onEdit}
      isEditable
      isEditMode={isEditMode}
      testId={'other-account-employment-information'}>
      {!isEditMode ? (
        <FinancialInformationEmploymentView accountHolder={accountHolder} testId={'other'} />
      ) : (
        <FinancialInformationEmploymentForm
          accountHolder={accountHolder}
          accountUuid={account?.id}
          onCancel={onCancel}
          testId={'joint'}
        />
      )}
    </MFormSection>
  );
};
